import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PropertyIntakeComponent } from '../../features/homeowner/property-intake/property-intake.component';
import { KrcFooter } from '../krc-footer/krc-footer';
import { KrcHeader } from '../krc-header/krc-header';
import { PropertyIntakeModalService } from '../../core/services/property-intake-modal.service';

@Component({
  selector: 'krc-main-layout',
  imports: [KrcHeader, KrcFooter, RouterOutlet, PropertyIntakeComponent],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout {
  readonly intakeModal = inject(PropertyIntakeModalService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  // Routes can opt out of the global header/footer via `data: { hideChrome: true }`
  // (e.g. the landing-v2 hero renders its own overlay nav bar).
  readonly hideChrome = signal(this.readHideChrome());

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.hideChrome.set(this.readHideChrome()));
  }

  private readHideChrome(): boolean {
    let child = this.route.snapshot.firstChild;
    while (child?.firstChild) { child = child.firstChild; }
    return !!child?.data['hideChrome'];
  }
}
